import type { GeofenceType } from '@cobliteam/common-types/src/geofenceV3';
import { colors } from '@cobliteam/ui/theme';
import { css } from 'emotion';
import GeofenceTypeItems from '../GeofenceTypeItems';

export const pinContainer = (type?: GeofenceType) => css`
  color: ${type ? GeofenceTypeItems[type].activeColor : colors.gray.dark};
  svg {
    width: 30px;
    height: 30px;
    margin-left: -10px;
    margin-top: -5px;
  }
`;
